<template>
    <div class="cadre">
        <h3>Catégorie</h3>
        <table>
            <thead>
                <tr>
                    <th>Libellé</th>
                    <th>
                        <div class="tab_outils">
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditCategorie"
                                    v-on:click="editCategorie(null)">
                                    <i class="material-icons"
                                        style="font-size:20px;color:black; display: flex;justify-content: flex-end">add_circle</i>
                                </a>
                            </div>
                        </div>
                    </th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="(categorie, index) in categories" :key="categorie.id">
                    <td>{{ categorie.libelle }}</td>
                    <td>
                        <div class="tab_outils">
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditCategorie"
                                    v-on:click="editCategorie(categorie.id)">
                                    <i class="material-icons" style="font-size:20px;color:black">edit</i>
                                </a>
                            </div>
                            <div>
                                <a v-on:click="deleteCategorie(index)">
                                    <i class="material-icons" style="font-size:20px;color:red">delete</i>
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <CategorieEdit :params="{ id: categorieEditId }" @saved="fetchCategorie" />

</template>

<script>
import Axios from '@/services/axios.service';
import CategorieEdit from './CategorieEdit.vue';

export default {
    name: 'CategorieIndex',
    components: {
        CategorieEdit,
    },
    data() {
        return {
            categories: [],
            categorieEditId: null,
        };
    },
    props: {
        msg: String
    },
    mounted() {
        this.fetchCategorie();
    },
    methods: {
        fetchCategorie() {
            Axios.get('/categorie/statut/ACTIF')
                .then(res => {
                    this.categories = res.data;
                })
                .catch(err => {
                    console.error('Erreur lors du chargement des categories :', err);
                });
        },
        deleteCategorie(index) {
            Axios.delete('/categorie/' + this.categories[index].id)
                .then(response => {
                    if (response.status == 200) {
                        this.categories.splice(index, 1)
                    }
                })
                .catch(err => {
                    alert(err)
                })
        },
        editCategorie(id) {
            this.categorieEditId = id;
        },
    }
}
</script>

<style></style>